<mat-button-toggle-group [value]="selectedVal">
  @if (allowGlobalHelpOverview) {
    <mat-button-toggle (click)="hierarchySelected()" value="hierarchy">{{
      'GLOBAL.HELP.OVERVIEW' | translate
    }}</mat-button-toggle>
  }
  @if (allowGlobalHelpContext) {
    <mat-button-toggle (click)="contextSelected()" value="context">{{
      'GLOBAL.HELP.QUICKACCESS' | translate
    }}</mat-button-toggle>
  }
</mat-button-toggle-group>
